import type { Filter, FiltersGroup, FiltersGroups, FilterDataOption } from '@/app/common/filters/core/filtersTypes.ts';
import { filterTypeOf } from '@/app/common/filters/types/filterTypeBehaviour.ts';
import { isOptionSelected } from '@/app/common/filters/core/filterOptionSelection.ts';

export const optionsOf = (filter: Filter): FilterDataOption[] => {
  if ('options' in filter.data) return filter.data.options ?? [];

  return [{ label: '', value: filter.name as string, selected: filterTypeOf(filter).isSelected(filter) }];
};

export const selectedValuesByGroup = (filtersGroups: FiltersGroups): Record<string, string[]> =>
  filtersGroups.reduce<Record<string, string[]>>((result, group) => {
    if (!('filters' in group)) return result;

    const values = (group as FiltersGroup).filters.flatMap((filter) =>
      optionsOf(filter)
        .filter(isOptionSelected)
        .map((option) => option.value)
    );

    return values.length ? { ...result, [group.id as string]: values } : result;
  }, {});
